module.exports = __webpack_public_path__ + "@/assets/img/equalizer.d009d3f7.svg";